module.exports = __webpack_public_path__ + "img/proxtiana-17.c8731828.jpg";